define(['jquery', 'common'], function ($, Common) {

	var MonitorPage = function() {
		var self = this;
		self.$ervBody = $('#erv-body');
		self.common = new Common();

		self.dashTypeSpecifics = function ($block, data) {
			var type = $block.data('type'),
				triggerValue = Number($block.data('triggervalue')),
				currentNumber = -1;
			var limit = triggerValue * 0.3;

			if (type === 'logs') {
				currentNumber = Number(data);

				$block.attr('class', '');

				if (triggerValue === 0) {
					triggerValue = 100;
				}

				self.setLogsClasses($block, currentNumber, limit, triggerValue);
			} else if (type === 'sales') {
				if (data.indexOf('No sales available') != -1) {
					$block.addClass('error text');
					return false;
				} else if (data.indexOf(',') != -1) {
					data = data.replace(',', '.');
				}

				currentNumber = Number(data);
				self.setSalesClasses($block, currentNumber);
			}

			self.triggerWarning($block, currentNumber, triggerValue, limit);
		};

		self.setSalesClasses = function($block, currentNumber) {
			$block.attr('class', '');
			if (currentNumber === 0) {
				$block.addClass('error');
			} else if (currentNumber > 0) {
				$block.addClass('debug');
			}
		};

		self.setLogsClasses = function($block, currentNumber, limit, triggerValue){
			if (currentNumber <= limit) {
				$block.addClass('debug');
			} else if (currentNumber > limit && currentNumber < triggerValue) {
				$block.addClass('warn');
			} else if (currentNumber >= triggerValue) {
				$block.addClass('error');
			}
		};

		self.triggerWarning = function($block, currentNumber, triggerValue, limit) {
			if (currentNumber >= triggerValue) {

				var shouldTrigger = false;

				if (typeof ($block.attr('data-nexttriggerpoint')) !== 'undefined') {
					if (currentNumber >= Number($block.attr('data-nexttriggerpoint'))) {
						shouldTrigger = true;
					}
				} else {
					shouldTrigger = true;
				}

				if (shouldTrigger) {
					self.warningSound($block, currentNumber, limit);
					self.warningBlink($block, 10);
					$block.attr('data-nexttriggerpoint', (currentNumber + limit));
				}
			}
		}

		self.warningSound = function ($block) {

			if ($block.find('audio').length !== 1) {
				return false;
			}

			var audio = $block.find('audio')[0];

			var isPlaying = audio.currentTime > 0 && !audio.paused && !audio.ended
				&& audio.readyState > 2;

			if (!isPlaying) {
				var promise = audio.play();

				if (promise !== undefined) {
					promise.then(function () {
						console.warn('ok promise');
					}).catch(function (error) {
						console.warn('no promise', error);
					});
				}
			}
		}

		self.warningBlink = function ($block, animationLoops) {
			var speed = 200;

			var intervalId = setInterval(function () {
				$block.fadeOut(speed).fadeIn(speed);

				animationLoops -= 1;
				if (animationLoops === 0) {
					clearInterval(intervalId);
				}
			}, speed * 2);
		}

		self.getDashData = function() {
			self.$ervBody.find('[data-fetchurl]').each(function() {
				var $fetchBlock = $(this);

				var url = $fetchBlock.data('fetchurl'),
					blockId = $fetchBlock.data('blockid'),
					triggerValue = $fetchBlock.data('triggervalue');

				if (typeof (triggerValue) !== 'undefined' && Number(triggerValue) > 0) {
					url += '&blockId=' + blockId;
					url += '&triggerValue=' + Number(triggerValue);
				}

				$.ajax({
					url: url,
					success: function(data) {
						$fetchBlock.find('[data-js="fetched"]').text(data);
						self.dashTypeSpecifics($fetchBlock, data);
					}
				});
			});
		};

		self.initDashBoard = function () {
			self.getDashData();

			setInterval(function() {
				self.getDashData();
			},
			45000);
		};

		self.escapeRegExp = function (str) {
			return str && str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
		};

		self.initGetLog = function() {
			var $form = self.$ervBody.find('form');

			var $dateToUpdate = self.$ervBody.find('.is-date');
            if ($dateToUpdate.length > 0) {
                self.common.forms.initDatePicker($dateToUpdate);
            }

			if ($form.length === 0 || $form.attr('action').indexOf('GetLog') < 0) {
				return false;
			}

			self.$ervBody.on('click', '.entry .level', function() {
				$(this).parent().toggleClass('is-expanded');
			});

			self.$ervBody.on('keyup', '#monitor-log-search', function() {
				var query = $(this).val(), entries = self.$ervBody.find('.entry');

				if (!query || !query.length) {
					entries.removeClass('hide');
					return;
				}

				var regex = new RegExp(self.escapeRegExp(query), 'i');
				entries.each(function() {
					$(this).toggleClass('hide', !regex.test($(this).text()));
				});
			});

			self.$ervBody.on('change', '#logfolder', function() {
				$(this).parents('form').submit();
			});
			self.$ervBody.on('change', '#selecteddate', function () {
                $(this).parents('form').submit();
            });
		};
	};

	MonitorPage.prototype.init = function () {
		var self = this;

		self.initGetLog();

		self.initDashBoard();
	}

	return MonitorPage;
});